import React from "react";
import { withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { isEmpty, get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import FormSection from "../../Common/FormSection";
import AddOccurrenceDateForm from "./AddOccurrenceDateForm";
import AddOccurrenceHostForm from "./AddOccurrenceHostForm";
import AddOccurrenceVisitorsForm from "./AddOccurrenceVisitorsForm";

import colors from "../../../assets/style/colors";
import { I18n } from "@aws-amplify/core";
import { displayColon } from "../../../utils/data";

const styles = {
  container: {
    backgroundColor: colors.lightGrey,
    padding: "8px",
    height: "100%",
  },
  containerTitle: {
    textTransform: "uppercase",
  },
  radio: {
    color: colors.black87,
    fontSize: "1em !important",
    marginRight: "40px !important",
  },
  radioRoot: {
    padding: "0px",
    marginRight: "10px",
  },
  controlLabel: {
    margin: "2px 0px",
  },
  checkboxRoot: {
    padding: 0,
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    userSelect: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const AddOccurrenceForm = (props) => {
  const {
    classes,
    companies,
    language,
    formValues,
    handleChange,
    hostAssociations,
    timeSlots,
    lov,
    edition,
    recurrenceLine
  } = props;
  
  return (
    <Grid item>
      <Grid container alignItems="center" style={{ marginBottom: "24px" }}>
        <Grid item className="text-87 bold-500">
          {I18n.get("scheduler_scheduleType")}
          {displayColon(language)}
        </Grid>
        <Grid item style={{ width: "210px", margin: "0px 30px 0px 8px" }}>
          <FormSection
            formValue={[get(formValues, ["scheduleType"]) || ""]}
            setFormValue={handleChange}
            id={"scheduleType"}
            noLabel
            noMarginBottom
            type="select"
            options={{
              disabled: edition,
              options: map(get(lov, ["scheduleTypes"]), (item) => ({
                id: item.id,
                name: get(item, ["name", language]),
              })),
            }}
          />
        </Grid>
        <Grid item className="text-87 bold-500">
          {I18n.get("profiles_name")}
          {displayColon(language)}
        </Grid>
        <Grid item style={{ width: "210px", margin: "0px 0px 0px 8px" }}>
          <FormSection
            formValue={[get(formValues, ["scheduleName"]) || ""]}
            setFormValue={handleChange}
            id={"scheduleName"}
            noLabel
            noMarginBottom
            type="input"
          />
        </Grid>
      </Grid>
      <Grid container wrap="nowrap">
        <Grid item style={{ width: "227px" }}>
          <AddOccurrenceDateForm
            classes={classes}
            formValues={formValues}
            handleChange={handleChange}
            timeSlots={timeSlots}
            edition={edition}
            recurrenceLine={recurrenceLine}
          />
        </Grid>
        <Grid item style={{ width: "336px", marginLeft: "12px" }}>
          <AddOccurrenceHostForm
            classes={classes}
            formValues={formValues}
            handleChange={handleChange}
            companies={companies}
          />
        </Grid>
        {!isEmpty(get(formValues, ["host"])) && (
          <Grid item xs style={{ marginLeft: "12px" }}>
            <AddOccurrenceVisitorsForm
              classes={classes}
              formValues={formValues}
              handleChange={handleChange}
              hostAssociations={hostAssociations}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: get(state, ["user", "companies"]),
    language: get(state, ["user", "language"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(AddOccurrenceForm));
